import { observer } from 'mobx-react';
import { Container } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { storeKrunica } from '../store/KrunicaStore';
import SlikaKrunicaAndeoska from './slike/SlikaKrunicaAndeoska';
import Amen from './Amen';
import OceNas from './OceNas';

const useStyles = makeStyles((theme) => ({
  opisZrnaKrunica: {
    display: 'flex',
    fontSize: '2rem',
    marginTop: '1rem',
    justifyContent: 'space-between',
    backgroundSize: '1.5rem',
    marginBottom: '2rem',
    textAlign: 'center',
    borderRadius: '0.2rem',
  },
  slikaKrunice: {
    position: 'relative',
    left: '0',
    top: '0',
    height: '80vh',
    width: '100%',
  },
  opisZrnaDesetice: {
    fontSize: '1.2rem',
    fontStyle: 'italic',
    marginTop: '0.2rem',
  },
  opisIsus: {
    fontSize: '1.6rem',
    // fontStyle: 'italic',
    marginTop: '1rem',
  },
  opisMolitve: {
    fontSize: '1.6rem',
    fontStyle: 'italic',
    marginTop: '1rem',
    color: 'blue',
  },
  opisLitanije: {
    fontSize: '1.4rem',
    textAlign: 'left',
    listStyle: 'none',
    // fontStyle: 'italic',
    // marginTop: '1rem',
  },
  nivo: {
    zIndex: '5',
  },
  [theme.breakpoints.up('sm')]: {
    backgroundColor: 'blue',
    color: '#555',
    border: '1px solid #ece7e7',
    slikaKrunice: {
      position: 'relative',
      left: '31%',
      top: '0',
      height: '100vh',
      width: '40%',
    },
    opisZrnaKrunica: {
      padding: '3rem',
    },
  },
}));

function KrunicaAndeoska() {
  const classes = useStyles();
  const { zrno, trenutnaKrunica, aktivnaZemlja } = storeKrunica;
  const {
    krunice,
    apostolskoVjerovanje,
    apostolskoVjerovanjeText,
    uImeOcaSina,
    litanijeSvetogMihovila,
  } = aktivnaZemlja;

  // console.log('zrno=', zrno);
  return (
    <div className={classes.slikaKrunice}>
      <Container>
        {zrno === -1 && <SlikaKrunicaAndeoska />}
        {zrno === 0 && (
          <div>
            <div className={classes.opisIsus}>
              {uImeOcaSina}
              <Amen />
            </div>
            <div className={classes.opisIsus}>{apostolskoVjerovanje}</div>
            <div className={classes.opisIsus}>{apostolskoVjerovanjeText}</div>
          </div>
        )}
        {zrno === 1 && (
          <div className={classes.opisIsus}>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.zaziv1Naslov}
            </div>
            {krunice.find((k) => k.value === trenutnaKrunica)?.zaziv1}
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.uCast1Kora}
            </div>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.oceNas}
            </div>
            <div className={classes.opisMolitve}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.zdravoMarije}
            </div>
          </div>
        )}
        {zrno === 2 && (
          <div className={classes.opisIsus}>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.zaziv2Naslov}
            </div>
            {krunice.find((k) => k.value === trenutnaKrunica)?.zaziv2}
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.uCast2Kora}
            </div>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.oceNas}
            </div>
            <div className={classes.opisMolitve}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.zdravoMarije}
            </div>
          </div>
        )}
        {zrno === 3 && (
          <div className={classes.opisIsus}>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.zaziv3Naslov}
            </div>
            {krunice.find((k) => k.value === trenutnaKrunica)?.zaziv3}
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.uCast3Kora}
            </div>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.oceNas}
            </div>
            <div className={classes.opisMolitve}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.zdravoMarije}
            </div>
          </div>
        )}
        {zrno === 4 && (
          <div className={classes.opisIsus}>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.zaziv4Naslov}
            </div>
            {krunice.find((k) => k.value === trenutnaKrunica)?.zaziv4}
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.uCast4Kora}
            </div>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.oceNas}
            </div>
            <div className={classes.opisMolitve}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.zdravoMarije}
            </div>
          </div>
        )}
        {zrno === 5 && (
          <div className={classes.opisIsus}>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.zaziv5Naslov}
            </div>
            {krunice.find((k) => k.value === trenutnaKrunica)?.zaziv5}
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.uCast5Kora}
            </div>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.oceNas}
            </div>
            <div className={classes.opisMolitve}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.zdravoMarije}
            </div>
          </div>
        )}
        {zrno === 6 && (
          <div className={classes.opisIsus}>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.zaziv6Naslov}
            </div>
            {krunice.find((k) => k.value === trenutnaKrunica)?.zaziv6}
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.uCast6Kora}
            </div>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.oceNas}
            </div>
            <div className={classes.opisMolitve}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.zdravoMarije}
            </div>
          </div>
        )}
        {zrno === 7 && (
          <div className={classes.opisIsus}>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.zaziv7Naslov}
            </div>
            {krunice.find((k) => k.value === trenutnaKrunica)?.zaziv7}
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.uCast7Kora}
            </div>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.oceNas}
            </div>
            <div className={classes.opisMolitve}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.zdravoMarije}
            </div>
          </div>
        )}
        {zrno === 8 && (
          <div className={classes.opisIsus}>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.zaziv8Naslov}
            </div>
            {krunice.find((k) => k.value === trenutnaKrunica)?.zaziv8}
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.uCast8Kora}
            </div>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.oceNas}
            </div>
            <div className={classes.opisMolitve}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.zdravoMarije}
            </div>
          </div>
        )}
        {zrno === 9 && (
          <div className={classes.opisIsus}>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.zaziv9Naslov}
            </div>
            {krunice.find((k) => k.value === trenutnaKrunica)?.zaziv9}
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.uCast9Kora}
            </div>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.oceNas}
            </div>
            <div className={classes.opisMolitve}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.zdravoMarije}
            </div>
          </div>
        )}
        {zrno === 10 && (
          <div className={classes.opisIsus}>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.uCast10Kora}
            </div>
            <div className={classes.opisIsus}>
              <OceNas />
            </div>
          </div>
        )}
        {zrno === 11 && (
          <div className={classes.opisIsus}>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.uCast11Kora}
            </div>
            <div className={classes.opisIsus}>
              <OceNas />
            </div>
          </div>
        )}
        {zrno === 12 && (
          <div className={classes.opisIsus}>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.uCast12Kora}
            </div>
            <div className={classes.opisIsus}>
              <OceNas />
            </div>
          </div>
        )}
        {zrno === 13 && (
          <div className={classes.opisIsus}>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.uCast13Kora}
            </div>
            <div className={classes.opisIsus}>
              <OceNas />
            </div>
          </div>
        )}
        {zrno === 14 && (
          <div className={classes.opisIsus}>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.slavniKneze}
            </div>
            <div className={classes.opisMolitve}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.moliZaNas}
            </div>
          </div>
        )}
        {zrno === 15 && (
          <div className={classes.opisIsus}>
            <div className={classes.opisIsus}>
              {krunice.find((k) => k.value === trenutnaKrunica)?.pomolimoSe}
            </div>
            <Amen />
          </div>
        )}
        {zrno === 16 && (
          <div>
            <ul className={classes.opisLitanije}>
              {litanijeSvetogMihovila.map((red, index) => {
                return (
                  <li key={index}>
                    {red.naslov && <strong>{red.naslov}</strong>}
                    {red.naslov ? ' ' : ''}
                    {red.tekst}
                    {red.odgovor && (
                      <span>
                        {' '}
                        — <b>{red.odgovor}</b>
                      </span>
                    )}
                  </li>
                );
              })}
            </ul>
            <div className={classes.opisIsus}>
              {uImeOcaSina}
              <Amen />
            </div>
          </div>
        )}
      </Container>
    </div>
  );
}

export default observer(KrunicaAndeoska);
